import React from "react";
import { CardBody, Input, Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import { FormControlLabel, Switch } from "@mui/material";
import styles from "../../styles.scss";
import SectionLabel from "../../common/sectionLabel";
import { LeftSidebarVariablesProp } from "../../common/types/variables";

const PostDetailMainSection = ({ variables }: LeftSidebarVariablesProp) => {
  const [giveButtonLabel, setGiveButtonLabel] = variables["giveButtonLabel"];
  const [postNormalCase, setPostNormalCase] = variables["postNormalCase"];

  return (
    <CardBody className={`${styles.cardBody} ${styles.postDetailSectionBody}`}>
      <div className={styles.section}>
        <SectionLabel
          label="Give button label"
          tooltip="Change the label on the Give button for post detail pages"
        />
        <Input
          type="text"
          value={giveButtonLabel ?? ""}
          onChange={e => setGiveButtonLabel(e.target.value)}
          className={styles.input}
        />
      </div>
      <div className={styles.section}>
        <FormControlLabel
          control={
            <Switch
              checked={!postNormalCase}
              onChange={e => setPostNormalCase(!e.target.checked)}
              color="primary"
            />
          }
          label={
            <Label className={styles.switchLabel}>Uppercase title</Label>
          }
        />
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(PostDetailMainSection);
